export const INTEL_ADMIN_IGNORE_ERRORS = ['TypeError: Failed to fetch'];
